import { withErrorBoundary } from "@sentry/react";

import Avatar from "@components/avatar/avatar";
import ErrorFallback from "@components/error-fallback/error-fallback";

import AskAIMessageMarkdown from "./ask-ai-message-markdown";
import { OverviewDirectReportsPlaceholderDirectReportType } from "./ask-ai-placeholders";

const AskAIPlaceholderOverviewDirectReportsComponent = ({
  overviewDirectReports,
}: {
  overviewDirectReports: null | {
    directReports: OverviewDirectReportsPlaceholderDirectReportType[];
  };
}) => {
  const directReports = overviewDirectReports?.directReports || [];

  return (
    <div className="flex flex-col gap-6">
      {directReports.length === 0 && (
        <div className="flex gap-2 items-center h-6">
          <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-5 w-5" />
          <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-5 w-36" />
        </div>
      )}
      {directReports.map((directReport) => (
        <div key={directReport.user.id || JSON.stringify(directReport)}>
          <div className="mb-2 flex gap-2 items-center tf-header-base-dark">
            <Avatar user={directReport.user} size="5" />
            <span>{directReport.user?.name || ""}</span>
          </div>
          {directReport.summary ? (
            <div className="prose prose-sm max-w-none">
              <AskAIMessageMarkdown>
                {directReport.summary}
              </AskAIMessageMarkdown>
            </div>
          ) : (
            <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-5 w-64" />
          )}
        </div>
      ))}
    </div>
  );
};

const AskAIPlaceholderOverviewDirectReportsWithSentry = withErrorBoundary(
  AskAIPlaceholderOverviewDirectReportsComponent,
  {
    fallback: ErrorFallback,
  },
);

export default AskAIPlaceholderOverviewDirectReportsWithSentry;
